<template>
  <div>
    <div class="area_main">
      <h2>{{ detailsInfo[`${currentLang.prefix}cate_name`] }}</h2>
      <p>
        {{ detailsInfo[`${currentLang.prefix}summary`] }}
      </p>
    </div>
    <div class="sy_one product__list">
      <el-carousel
        class="exhibitors_swiper"
        :interval="2500"
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        :loop="true"
      >
        <el-carousel-item
          class="exhibitors-item"
          v-for="(itmData, idx) in exhibitorsSwiper"
          :key="idx"
        >
          <div class="exhibitors-item-box flex-center-center">
            <!-- 循环每个el-carousel-item要展示的数组 -->
            <section
              class="exhibitors-item-section"
              v-for="(item, index) in itmData"
              :key="index"
            >
              <div class="img_wrap">
                <img
                  class="exhibitors-item-img"
                  :src="item.full_image"
                  alt=""
                />
              </div>

              <div class="exhibitors-item-title">
                {{ item[`${currentLang.prefix}title`] }}
              </div>
              <div class="exhibitors-item-desc" v-html="$convertPxToRem(item[`${currentLang.prefix}content`])"></div>
              <div class="dynamic_btn" @click="goProductDetail(item)">
                <span>MORE</span>
                <img
                  class="more_btn"
                  src="../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </section>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div
      class="sy_two"
      :style="{
        background: 'url(' + detailsInfo.full_image + ') center center'
      }"
    >
      <div>
        <h2>{{ applicationDetail.titleOne }}</h2>
        <p>
          {{ detailsInfo[`${currentLang.prefix}summary2`] }}
        </p>
      </div>
    </div>
    <!--<div class="sy_three" style="height: auto;">
       <div class="dynamic_block">
        <h2>{{ applicationDetail.titleTwo }}</h2>
      </div> 
	   <div class="sy_one">
	    <el-carousel
	      class="exhibitors_swiper"
	      :interval="2500"
	      indicator-position="none"
	      arrow="always"
	      :autoplay="false"
	    >
	      <el-carousel-item
	        class="exhibitors-item"
	        v-for="(itmData, idx) in exhibitorsSwiperNew"
	        :key="idx"
	      >
	        <div class="exhibitors-item-box flex-center-center">
	          <section
	            class="exhibitors-item-section"
	            v-for="(item, index) in itmData"
	            :key="index"
	          >
	          <div class="img_wrap">
	            <img class="exhibitors-item-img" :src="item.full_image" alt="" />
	          </div>
	            
	            <p style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                {{ item[`${currentLang.prefix}title`] }}
              </p>
	            <div class="dynamic_btn" @click="goProgramDetails(item.id)">
	              <span>MORE</span>
	              <img
	                class="more_btn"
	                src="../../assets/images/public/arrow1.png"
	                alt=""
	              />
	            </div>
	          </section>
	        </div>
	      </el-carousel-item>
	    </el-carousel>
	  </div>
    </div> -->
    <div class="sy_three" style="height:auto;" v-if="detailsInfo[`${currentLang.prefix}content`]">
      <div class="dynamic_block">
        <div v-html="$convertPxToRem(detailsInfo[`${currentLang.prefix}content`])" style="display:inline-block;"></div>
      </div> 
      
    </div>
    <div class="sy_four">
      <h2>{{ applicationDetail.titleThree }}</h2>
      <div class="four_wrap">
        <div
          v-for="(item, i) in detailsInfo.applicationandsolution_list"
          :key="i"
          class="four_li flex f-column f-ali-center"
          @click="goProgramDetails(item.id, item.cate[`${currentLang.prefix}cate_name`], 1)"
        >
          <img
            :src="'https://miniapp.kelkflow.com/' + item.ico_image"
            class="sy_four-icon"
          />
          <div class="sy_four-title">
            {{ item[`${currentLang.prefix}title`] }}
          </div>
        </div>
      </div>
    </div>
    <div class="sy_five">
      <div class="dynamic_block">
        <h2>{{ applicationDetail.titleFour }}</h2>      
      </div>
      <div class="sy_one sy_one-two" style="">
          <el-carousel
            class="exhibitors_swiper"
            :interval="2500"
            indicator-position="none"
            arrow="always"
            :autoplay="false"
          >
            <el-carousel-item
              class="exhibitors-item"
              v-for="(itmData, idx) in exhibitorsSwiperNew"
              :key="idx"
            >
              <div class="exhibitors-item-box flex-center-center">
                <section
                  class="exhibitors-item-section"
                  v-for="(item, index) in itmData"
                  :key="index"
                >
                  <div class="img_wrap">
                    <img
                      class="exhibitors-item-img"
                      :src="item.full_image"
                      alt=""
                    />
                  </div>
                  <div class="exhibitors-item-title">
                    {{ item[`${currentLang.prefix}title`] }}
                  </div>
                  <p class="exhibitors-item-desc">{{ item[`${currentLang.prefix}summary`] }}</p>
                  <div class="dynamic_btn" @click="goProgramDetails(item.id, item.cate[`${currentLang.prefix}cate_name`])">
                    <span>MORE</span>
                    <img
                      class="more_btn"
                      src="../../assets/images/public/arrow1.png"
                      alt=""
                    />
                  </div>
                </section>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
    </div>
  </div>
</template>

<script>
import { getCateDetailInfo } from "@/utils/http.js";
import { mapGetters } from "vuex";

export default {
  props: ["detailsId"],
  data() {
    return {
      detailsInfo: {},
      exhibitorsData: [],
      exhibitorsSwiper: [],
      exhibitorsSwiperNew: [],
      exhibitorsSwiperNews:[]
    };
  },
  computed: {
    ...mapGetters(["currentLang"]),
    applicationDetail() {
      return this.currentLang.config.applicationAreaPage.applicationDetail;
    }
  },
  watch: {
    detailsId: {
      handler(newVal, oldVal) {
        this.getDetails();
      },
      deep: true
    }
  },
  mounted() {
    this.getDetails();
    //数据拆分
  },
  methods: {
    getDetails() {
      getCateDetailInfo({ cate_id: this.detailsId }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.detailsInfo = res.data;
          this.getExhibitorsData();
        }
      });
    },
    goProgramDetails(id, cateName, byFrom) {
      this.$router.push({
        path: "/programDetail",
        query: { id: this.detailsId, sonId: id, activeNameText: cateName, from: byFrom ? byFrom : '' }
      });
    },
    goProductDetail(info){
      console.log(info)
      this.$router.push({ path: "/prod_details", query: { 
          id: info.cate_id,
          sonId: info.id
        } 
      });
    },
    getExhibitorsData() {
      this.exhibitorsSwiper = []
      this.exhibitorsSwiperNew = []
      let dataList = this.detailsInfo.product_list; //获取到数据
      let dataListNew = this.detailsInfo.industry_list;
      for (let i = 0; i < dataList.length; i += 3) {
        this.exhibitorsSwiper.push(dataList.slice(i, i + 3));
      }
      for (let i = 0; i < dataListNew.length; i += 3) {
        this.exhibitorsSwiperNew.push(dataListNew.slice(i, i + 3));
      }
      console.log('this.exhibitorsSwiper', this.exhibitorsSwiper)
    }
  }
};
</script>
<style lang="scss" scoped>
.area_main {
  width: 1200px;
  height: auto;
  margin: 60px auto;
  background: white;
  text-align: center;
  line-height: 1.8;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
    font-size: 18px;
  }
}

.product__list {
 
  .exhibitors-item-section {
    padding-bottom: 15px;
    border: 1px solid #ececec;
  }

  .exhibitors-item-title {
    padding: 0 16px;
    margin: 20px 0 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    font-size: 20px!important;
    font-weight: 500;
    font-size: 20px;
    color: var(--main-color-blue);
    letter-spacing: 1px;
  }

  .exhibitors-item-desc {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    line-clamp: 2;
    -webkit-line-clamp: 2; //显示几行
    max-height: 48px;
    margin: 20px 0 30px;
    padding: 0 16px;
    font-size: 16px;
    text-align: justify;
    text-align-last: center;
    line-height: 1.6;
    color: #555;
  }
}

.sy_one {
  width: 100%;
  margin: 0 auto 50px;
  display: flex;
  background: white;
  justify-content: space-around;
  text-align: center;
  .exhibitors_swiper {
    width: 100%;
    /deep/ .el-carousel__container {
      height: 600px!important;
    }
    .flex-center-center {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .exhibitors-item-section {
        width: 380px;
        .img_wrap {
          width: 100%;
          height: 360px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .exhibitors-item-img {
          width: auto;
          height: 100%;
          display: block;
          // object-fit: contain;
        }
        p {
          font-size: 18px;
          margin-top: 8px;
        }
        .dynamic_btn {
          width: 140px;
          height: 45px;
          background: #e8363e;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          margin: 25px auto 0;
          cursor: pointer;

          .more_btn {
            width: 40px;
            margin-left: 10px;
          }
        }
      }
    }
    /deep/ .el-carousel__arrow {
      width: 50px;
      height: 50px;
      border-radius: 0;
      font-size: 20px;
      background: #666;
    }
    /deep/ .el-carousel__arrow--left {
      left: 0;
    }
    /deep/ .el-carousel__arrow--right {
      right: 0;
    }
  }
}

.sy_one-two {
  margin-bottom: 100px;
  margin-top: 48px;
}

.sy_two {
  width: 100%;
  height: auto;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  margin-top: 50px;
  padding: 125px 0;

  div {
    width: 1200px;
    height: auto;
    background: white;
    opacity: 0.9;
    margin: 0 auto;
    text-align: center;
    padding: 30px 0 100px 0;

    h2 {
      color: #323232;
      font-weight: normal;
      margin-bottom: 30px;
    }

    p {
      width: 90%;
      margin: auto;
    }
  }
}
.sy_three {
  width: 100%;
  height: 700px;
  background: white;
  display: inline-block;

  .dynamic_block {
    display: flex;
    justify-content: center;
    width: 1200px;
    height: 100%;
    margin: 50px auto;
    // text-align: center;

    font-size: 16px;
    line-height: 1.8;
    text-indent: 2rem;
    text-align: justify;
    color: #666;

    h2 {
      color: #323232;
      font-weight: normal;
      margin-bottom: 30px;
      margin-top: 80px;
    }

    .dynamic_nav {
      display: flex;
      justify-content: space-between;
      margin-top: 48px;

      li {
        width: 380px;
        background: #f5f5f5;

        .dynamic_img {
          width: 380px;
          height: 280px;
        }

        .dynamic_content {
          padding: 30px 30px 20px;
          background: #f5f5f5;

          .dynamic_name {
            text-align: left;
            font-size: 20px;
          }

          .dynamic_btn {
            width: 140px;
            height: 45px;
            margin-top: 40px;
            background: #e8363e;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;

            .more_btn {
              width: 40px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}
.sy_four {
  width: 100%;
  height: auto;
  background: #003359;
  text-align: center;
  padding: 70px 0;
  h2 {
    color: white;
    font-weight: normal;
    // margin-bottom: 70px;
  }
  .four_wrap {
    width: 1200px;
    display: flex;
    flex-wrap: wrap;
    margin: 10px auto;
    justify-content: space-around;
    color: white;
    .four_li {
      box-sizing: border-box;
      position: relative;
      // width: 360px;
      width: 15%;
      height: 210px;
      padding: 20px 6px 0;
      margin-top: 10px;
      transition: all 0.3s ease-out;
      cursor: pointer;
      
      // box-shadow: 0 0 14px 4px rgba(58, 142, 150, 0.3);
    }

    .four_li:hover {
      box-shadow: 0 0 14px 4px rgba(58, 142, 150, 0.4);
      border-radius: 4px;
    }
  }

  .sy_four-icon {
    margin-bottom: 40px;
    width: 70px;
    height: 70px;
  }

  .sy_four-title {
    font-size: 18px;
    font-weight: 500;
  }
}
.sy_five {
  width: 100%;
  height: auto;
  background: white;
  display: inline-block;

  .dynamic_block {
    width: 1200px;
    height: 100%;
    margin: 0 auto;

    h2 {
      font-weight: normal;
      margin-top: 65px;
      text-align: center;
      color: #323232;
    }

    .dynamic_nav {
      width: 100%;
      display: flex;
      // align-items: flex-start;
      flex-wrap: wrap;
      

      li {
        // width: 580px;
        width: 32%;
        background: #f5f5f5;
        margin-top: 20px;
        text-align: justify;
        margin-right: 24px;
        &:nth-child(3n) {
          margin-right: 0;
        }
        .dynamic_img {
          // width: 580px;
          width: 100%;
          height: auto;
        }

        .dynamic_content {
          padding: 20px 30px 20px;
          background: #f5f5f5;

          .dynamic_name {
            font-size: 20px;
          }

          .dynamic_time {
            margin-top: 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            span {
              color: gray;
            }
          }

          .dynamic_btn {
            width: 140px;
            height: 45px;
            margin-top: 40px;
            background: #e8363e;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;

            .more_btn {
              width: 40px;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }

  .sy_one.sy_one-two {
    
    .exhibitors_swiper /deep/ .el-carousel__container {
      height: 600px!important;
    }

    .exhibitors-item-box {
      padding: 20px 0;
    }

    .exhibitors-item-section {
      padding: 0 0 15px;
      cursor: pointer;
      width: 30%;
    }
    // .exhibitors-item-section,
    .exhibitors-item-section:hover {
      transition: all 0.5s;
      box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      overflow: hidden;
    }

    .exhibitors-item-img {
      display: block;
    }

    .exhibitors-item-title {
      padding: 0 12px;
      margin: 20px 0 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      font-weight: 500;
      font-size: 20px;
      color: var(--main-color-blue);
    }

    p.exhibitors-item-desc {
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      line-clamp: 2;
      -webkit-line-clamp: 2; //显示几行
      height: 48px;
      margin: 20px 0 30px;
      padding: 0 12px;
      font-size: 16px;
      text-align: justify;
      text-align-last: center;
      line-height: 1.6;
      color: #555;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/yyly/yyly1.vue